const getCookieDomain = (url: string): string | null => {
  try {
    const parsedUrl = new URL(url)
    const hostname = parsedUrl?.hostname

    if (hostname === 'localhost') {
      return hostname
    }

    const parts = hostname.split('.')

    if (parts.length >= 2) {
      const mainDomain = parts.slice(-2).join('.')

      if (mainDomain === 'com.br') {
        return `.${parts.slice(-3).join('.')}`
      }

      return `.${mainDomain}`
    }

    return null
  } catch (error) {
    console.error('Invalid URL: ', error)
    return null
  }
}

export { getCookieDomain }
